import * as React from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    FormControl,
    InputLabel,
    OutlinedInput,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
    Typography,
    Card,
    styled,
} from "@mui/material";

import SchoolIcon from "@mui/icons-material/School";

/* ✅ New Premium Background Image */
const bgImage =
    "https://images.unsplash.com/photo-1499951360447-b19be8fe80f5";

/* ✅ Styled Components */
const PageWrapper = styled(Box)(({ theme }) => ({
    minHeight: "100vh",
    backgroundImage: `linear-gradient(rgba(16,7,32,0.9), rgba(16,7,32,0.95)), url(${bgImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: "60px",
    paddingTop: "120px",
    color: "white",
}));

const GlassCard = styled(Card)(({ theme }) => ({
    backgroundColor: "rgba(255,255,255,0.95)",
    borderRadius: "12px",
    padding: "30px",
    width: 380,
    textAlign: "center",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
}));

/* ✅ Dropdown Menu Styling */
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const trainings = [
    "Basic Plan",
    "Standard Plan",
    "Premium Individual",
];

export default function ProgramTrainingBooking() {
    const [programTraining, setProgramTraining] = React.useState([]);
    const navigate = useNavigate();

    const handleChange = (event) => {
        const { value } = event.target;
        const selected = typeof value === "string" ? value.split(",") : value;
        setProgramTraining(selected);

        if (selected.length > 0) {
            navigate("/plan-application-page");
        }
    };

    return (
        <PageWrapper>
            <GlassCard>
                {/* ✅ Golden Banner Title */}
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 800,
                        backgroundColor: "goldenrod",
                        color: "#100720",
                        display: "inline-block",
                        px: 4,
                        py: 1,
                        borderRadius: "999px",
                        mb: 3,
                    }}
                >
                    Training Plans
                </Typography>

                {/* ✅ Icon + Subtitle */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 3,
                    }}
                >
                    <SchoolIcon sx={{ color: "goldenrod", fontSize: 40, mr: 1 }} />
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 700,
                            color: "#100720",
                            letterSpacing: 1,
                        }}
                    >
                        Choose Your Path
                    </Typography>
                </Box>

                {/* ✅ Select Input */}
                <FormControl fullWidth>
                    <InputLabel
                        id="select-training-label"
                        sx={{ color: "#100720", fontWeight: 700 }}
                    >
                        Select Training Plan
                    </InputLabel>

                    <Select
                        labelId="select-training-label"
                        multiple
                        value={programTraining}
                        onChange={handleChange}
                        input={<OutlinedInput label="Select Training Plan" />}
                        renderValue={(selected) => selected.join(", ")}
                        MenuProps={MenuProps}
                        sx={{
                            color: "#100720",
                            fontWeight: 600,
                            "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "goldenrod",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#e0b200",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: "goldenrod",
                            },
                        }}
                    >
                        {trainings.map((training) => (
                            <MenuItem key={training} value={training}>
                                <Checkbox checked={programTraining.includes(training)} />
                                <ListItemText primary={training} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </GlassCard>
        </PageWrapper>
    );
}
